import { initialize } from 'redux-form';

export const initializeForm = (form, data, options) =>
	initialize(form, data, {
		keepDirty: true,
		updateUnregisteredFields: true,
		...options,
	});
